@if (show()) {
  <div class="global-notification mat-elevation-z2">
    <div class="message-wrapper">
      <div class="message">
        <span class="message-text" [innerHTML]="message | linky"></span>
      </div>
      <div class="close-button-wrapper">
        <button mat-flat-button class="dismiss" (click)="dismiss()">
          {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
}
